export default __webpack_public_path__ + "d6415e981f0be56558b17cf7c8d2cc0b.jpg";